import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { autofill, Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import { AutoComplete } from 'antd';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';


var url =  window.location.hostname;
var port = window.location.port;
 const Heading = [
    ['Product Code', 'Parent Code ', 'Parent Product Description', 'Product Code', 'CBU Code', 'MRP', 'Non-PTL', 'UPC','Product Name ','Category','Sub Category','Brand','Sub Brand','Company','Product Type','Storage Type',  'Shade Applicable', 'Shade Code', 'Shade Name', 'Offer',  'Tester', 'Tester Code',  'Tester Ratio','Barcode Type',  'CBU Tester Flag',  'LB Type',  'LB Type Analysis', 'ID Number' ,'Ean', 'ICLD Ean Status' ,'ICLD Ean Time', 'OCLD Ean Status','OCLD Ean Time',  'Ref LB SKU ID',  'Outer Carton Ean', 'CPO',  'Ocld Applicable',  'Carton Length' ,'Carton Breadth',  'Carton Height',  'Carton Volume','Product Length', 'Product Breadth',  'Product Height', 'ICLD Ean', 'ICLD Volume',  'Length', 'Breadth',  'Height','Inner Length','inner Breadth','Inner Height','Fast Moving', 'Shelf Life','SKU5 Code', 'Update Date Time', 'Updated On', 'Volume', 'Status',  "Price lot","Uom","Pack Size","Pack size uom","Weight" ,"Created Date Time","Added on",'Created By','Updated By','UPC Updated By']
];





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);
   this.Successtoggle = this.Successtoggle.bind(this);
   this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
   this.ConfirmToggle = this.ConfirmToggle.bind(this);
   this.openConfirm = this.openConfirm.bind(this);

   /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
    loading_overlay: false, 
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      filtered_orderData : [],
      selectedFileType: '',
    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

 

  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentDidMount(){
  this.fetchBinData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  SuccesstoggleCancel(){
    this.setState({
        Successmodal: false
    })

    if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }
  }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  ConfirmToggle(){
    this.setState(prevState => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm(){
    this.setState({
      ConfirmModal: true
    })

  }


 
  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })


    const payload={}
API.get('/product/product_master/v1/view/', { param: payload })
            
      .then(response => response.data)

      .then(data => {
        
         this.setState({ posts: data.data ,filtered_orderData :data.data  })
         
      })
      

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }



 

  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {
          base_pack_code: post.parent_code,
          base_pack_desc: post.parent_product_desc,
          product_type: post.product_type,


          category: post.category,
          sub_category: post.sub_category,
          lb_sku_id: post.lb_sku_id,
          lb_sku_product_name: post.product_name,

          storage_type: post.storage_type,
          shade_applicable: post.shade_applicable,

          shade_code: post.shade_code,
          shade_name: post.shade_name,
          company: post.company,
          brand: post.brand,
          mrp: post.mrp,
          non_ptl: post.non_ptl.toString(),
          offer: post.offer,
          height: post.height,
          tester: post.tester,
          sku7_code: post.product_code,
          tester_code: post.tester_code,
          tester_ratio: post.tester_ratio,
          barcode_type: post.barcode_type,
          cbu_tester_flag: post.cbu_tester_flag,
          lb_type: post.lb_type,
          lb_type_analysis: post.lb_type_analysis,
          id_number: post.id_number,
          ean : post.each_ean,
          icld_ean_verified_status: post.icld_ean_verified_status,
          icld_ean_verified_time: post.icld_ean_verified_time,
          ocld_ean_verified_status: post.ocld_ean_verified_status,
          ocld_ean_verified_time: post.ocld_ean_verified_time,
          reference_lb_sku_id: post.reference_lb_sku_id,
          outerCartonEAN: post.outer_ean,
          cpo: post.cpo,
          upc: post.upc,
          ocldApplicable: post.ocldApplicable,
          cartonLength: post.cartonLength,
          cartonBreadth: post.cartonBreadth,
          cartonHeight: post.cartonHeight,
          cartonVolume: post.cartonVolume,
          productLength: post.productLength,
          productBreadth: post.productBreadth,
          productHeight: post.productHeight,
          icld_ean:post.inner_ean,
          icld_volume: post.inner_volume,
          length: post.length,
          inner_length : post.inner_length,
          inner_breadth : post.inner_breadth,
          inner_height : post.inner_height,
          //mrp: post.mrp,
          ocld_applicable: post.ocld_applicable,
          cbu_code: post.cbu_code,
          breadth: post.breadth,
          
          sub_brand: post.sub_brand,
          fast_moving: post.fast_moving,


          shelf_life: post.shelf_life,
          sku5_code: post.sku5_code,

          

          updated_date_time: post.updated_date_time,
          
          updated_on: post.updated_on,
          
          
          volume: post.each_volume,
          status: post.status,
          upc_updated_by: post.upc_updated_by
          
        }

      )

    });

    this.setState({
    loading_overlay: false
    })

    return posts;

  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      
      // var value = this.state.posts.filter(
      //   (val) =>
        
      //     val.lb_sku_id.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.parent_product_desc.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.parent_code.toString().includes(evt.toLowerCase()) ||
      //     val.product_code.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.category.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.mrp.toString().includes(evt.toLowerCase()) ||
      //     val.upc.toString().includes(evt.toLowerCase()) ||
      //     val.product_name.toLowerCase().includes(evt.toLowerCase()) || 
      //     val.cbu_code.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.sub_category.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.brand.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.sub_brand.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.company.toLowerCase().includes(evt.toLowerCase()) ||
      //     val.status.toLowerCase().includes(evt.toLowerCase())  ||
      //     val.reference_lb_sku_id.toLowerCase().includes(evt.toLowerCase())
      //     // val.carton_height.toString().includes(evt.toLowerCase())  ||
      //     // val.carton_volume.toString().includes(evt.toLowerCase())  

      // );
      var value = this.state.posts.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      

      this.setState({
        filtered_orderData: value,
      });
    }
  };

 

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [
        {

          label:'LB Product Code',

          field:'lb_sku_id',
          sort: 'asc',
          width: 150

        },
        {

          label:'Parent Code',

          field:'base_pack_code',
          sort: 'asc',
          width: 230

        },

        
        {

          label:'Parent Product Description',

          field:'base_pack_desc',
          sort: 'asc',
          width: 300

        },
        {

          label:'Product Code',

          field:'sku7_code',
          sort: 'asc',
          width: 200

        },
        {

          label:'CBU Code',

          field:'cbu_code',
          sort: 'asc',
          width: 150

        },
        {

          label:'MRP',

          field:'mrp',
          sort: 'asc',
          width: 150

        },
        {

          label:'Non-PTL',

          field:'non_ptl',
          sort: 'asc',
          width: 120

        },
        {

          label:'UPC',

          field:'upc',
          sort: 'asc',
          width: 150

        },

        {

          label:'Product Name',

          field:'lb_sku_product_name',
          sort: 'asc',
          width: 250

        },

        {

          label:'Category',

          field:'category',
          sort: 'asc',
          width: 110

        },

        {

          label:'Sub Category',

          field:'sub_category',
          sort: 'asc',
          width: 150

        },

        {

          label:'Brand',

          field:'brand',
          sort: 'asc',
          width: 150

        },

        {

          label:'Sub Brand',

          field:'sub_brand',
          sort: 'asc',
          width: 150

        },

        {

          label:'Company',

          field:'company',
          sort: 'asc',
          width: 150

        },


        {

          label:'Product Type',

          field:'product_type',
          sort: 'asc',
          width: 150

        },


        {

          label:'Storage Type',

          field:'storage_type',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Applicable',

          field:'shade_applicable',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Code',

          field:'shade_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shade Name',

          field:'shade_name',
          sort: 'asc',
          width: 150

        },

        

        {

          label:'Offer',

          field:'offer',
          sort: 'asc',
          width: 150

        },



        {

          label:'Tester',

          field:'tester',
          sort: 'asc',
          width: 150

        },

       

        {

          label:'Tester Code',

          field:'tester_code',
          sort: 'asc',
          width: 150

        },

        {

          label:'Tester Ratio',

          field:'tester_ratios',
          sort: 'asc',
          width: 150

        },

          {

          label:'Barcode Type',

          field:'barcode_type',
          sort: 'asc',
          width: 150

        },

          {

          label:'CBU Tester Flag',

          field:'cbu_tester_flag',
          sort: 'asc',
          width: 180

        },

          {

          label:'LB Type',

          field:'lb_type',
          sort: 'asc',
          width: 150

        },

          {

          label:'LB Type Analysis',

          field:'lb_type_analysis',
          sort: 'asc',
          width: 180

        },

          {

          label:'ID Number',

          field:'id_number',
          sort: 'asc',
          width: 150

        },

        {

          label:'Ean',

          field:'ean',
          sort: 'asc',
          width: 150

        },

          {

          label:'ICLD Ean Status',

          field:'icld_ean_verified_status',
          sort: 'asc',
          width: 150

        },

          {

          label:'ICLD Ean Time',

          field:'icld_ean_verified_time',
          sort: 'asc',
          width: 150

        },

          {

          label:'OCLD Ean Status',

          field:'ocld_ean_verified_status',
          sort: 'asc',
          width: 150

        },

          {

          label:'OCLD Ean Time',

          field:'ocld_ean_verified_time',
          sort: 'asc',
          width: 150

        },

        {

          label:'Ref LB SKU ID',

          field:'reference_lb_sku_id',
          sort: 'asc',
          width: 180

        },

        {

          label:'Outer Carton Ean',

          field:'outerCartonEAN',
          sort: 'asc',
          width: 150

        },

        {

          label:'CPO',

          field:'cpo',
          sort: 'asc',
          width: 150

        },

       

        {

          label:'Ocld Applicable',

          field:'ocldApplicable',
          sort: 'asc',
          width: 150

        },

         {

          label:'Carton Length',

          field:'cartonLength',
          sort: 'asc',
          width: 150

        },

        {

          label:'Carton Breadth',

          field:'cartonBreadth',
          sort: 'asc',
          width: 150

        },

        {

          label:'Carton Height',

          field:'cartonHeight',
          sort: 'asc',
          width: 150

        },

        {

          label:'Carton Volume',

          field:'cartonVolume',
          sort: 'asc',
          width: 150

        },

        {

          label:'Product Length',

          field:'productLength',
          sort: 'asc',
          width: 150

        },

        {

          label:'Product Breadth',

          field:'productBreadth',
          sort: 'asc',
          width: 150

        },

        {

          label:'Product Height',

          field:'productHeight',
          sort: 'asc',
          width: 150

        },

         
         {

          label:'ICLD Ean',

          field:'icld_ean',
          sort: 'asc',
          width: 150

        },

         {

          label:'ICLD Volume',

          field:'icld_volume',
          sort: 'asc',
          width: 150

        },
        

        {

          label:'Length',

          field:'length',
          sort: 'asc',
          width: 150

        },

        {

          label:'Breadth',

          field:'breadth',
          sort: 'asc',
          width: 150

        },

       
        {

          label:'Height',

          field:'height',
          sort: 'asc',
          width: 150

        },
        {

          label:'Inner Length',

          field:'inner_length',
          sort: 'asc',
          width: 150

        },

        {

          label:'Inner Breadth',

          field:'inner_breadth',
          sort: 'asc',
          width: 150

        },

       
        {

          label:'Inner Height',

          field:'inner_height',
          sort: 'asc',
          width: 150

        },

        {

          label:'Fast Moving',

          field:'fast_moving',
          sort: 'asc',
          width: 150

        },

        {

          label:'Shelf Life',

          field:'shelf_life',
          sort: 'asc',
          width: 150

        },

        {

          label:'SKU5 Code',

          field:'sku5_code',
          sort: 'asc',
          width: 150

        },


       

        {

          label:'Update Date Time',

          field:'updated_date_time',
          sort: 'asc',
          width: 150

        },
        {

          label:'Updated On',

          field:'updated_on',
          sort: 'asc',
          width: 150

        },
        
        {

          label:'Volume',

          field:'volume',
          sort: 'asc',
          width: 220

        },
        {

          label:'Status',

          field:'status',
          sort: 'asc',
          width: 220

        },
        {

          label:'UPC Updated By',

          field:'upc_updated_by',
          sort: 'asc',
          width: 220

        },
        
         

        

      ],

      rows:this.state.tableRows,

    }


    return (
      <Col xl={12}>
     {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          

          {
            this.state.showRowDataError  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text"> Please upload file again. </h4>
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Reason</th>
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.ErrorRowData.length>0 && (
                      this.state.ErrorRowData.map((item, index) => (
                        <tr>
                          <td>{item['Bin']}</td>
                          <td style={{color:'red'}}> Column is missing </td>
                                           
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }




          {
            this.state.showInvalidItem  && (
                <CardBody style={{marginTop: 20}}>
                  <div>
                  {this.state.show_process_data &&
                    <h4 style={{color: 'red', fontWeight: 'bold'}} className="subhead red-text">
                      <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12}} className="modal_ok show_bin_proceed"  onClick={this.openConfirm}>

                        {this.state.loading && 
                          <i
                            className="fa fa-refresh fa-spin"
                            style={{ marginRight: "5px" }}
                          />
                        }
                      Proceed</Button>
                     </h4>
                  }
                  </div>
                  <Table responsive className="table--bordered">
                    <thead>
                      <tr>
                        <th>BIN ID</th>
                        <th>Response</th>
                        
                        
                      </tr>
                    </thead>
                    <tbody>
                    {
                      this.state.responseFailBinData.failure_response.length>0 && (
                      this.state.responseFailBinData.failure_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'red'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }

                    {
                      this.state.responseSuccessBinData.success_response.length>0 && (
                      this.state.responseSuccessBinData.success_response.map((item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{color: 'green'}}>{item.message}</td>
                          
                        </tr>
                      )))
                    }


                    </tbody>
                  </Table>
                </CardBody>
            )
          }

          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 3}}>
            <div className="table_header" style={{borderBottomWidth:'0px'}}>
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">LB Product Master</h4>
              
        <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.filtered_orderData, "Lb Product Master", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
      <hr style={{marginTop:'30px',marginBottom:'0px'}}/>
            
          <MDBDataTable
                  scrollX
                  sortable={false}
                  onSearch = {this.filterData}
                  displayEntries={false}
                  striped
                  bordered
                  data={data}
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'lb_product_master_view', 'datatable_pagination_change' )}
                />
          </CardBody>

          )}




        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Successtoggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{maxWidth: 456}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.ConfirmToggle} />
           
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4 style={{fontSize: 18}}> Are you sure you want to proceed?</h4>
            <br/>
            <h3 style={{fontSize: 17}}><strong> NOTE: </strong> Duplicate entries will be updated if you proceed. </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff' , marginRight: 8}} className="modal_ok"  onClick={this.processData}>Ok</Button>
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.ConfirmToggle}>Cancel</Button>
          </ButtonToolbar>
        </Modal>





      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));